var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "MMV" },
    [
      _c(
        "div",
        {
          staticClass: "MMV__head",
          class: { _open: _setup.isHeadExpanded },
          on: { click: _setup.HeadExpand_click },
        },
        [
          _c(
            "div",
            { staticClass: "MMV__head-open" },
            [
              _c(_setup.vDown, {
                staticClass: "vicon-black MMV__head-open__icon",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "MMV__head__title" },
            [
              _vm._t("default", function () {
                return [_vm._v("Название поля")]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _setup.choosedset.size
            ? _c("div", { staticClass: "MMV__head-count" }, [
                _vm._v(_vm._s(_setup.choosedset.size)),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _setup.isHeadExpanded
        ? [
            _setup.choosedset.size && _setup.needSeach
              ? _c(
                  "div",
                  { staticClass: "MMV__selected" },
                  _vm._l(_setup.selected, function (option) {
                    return _c(_setup.MyMultiVertOption, {
                      key: option.id,
                      attrs: { item: option },
                      on: { input: _setup.set_option },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.needSeach
              ? _c(
                  "div",
                  { staticClass: "MMV__searchbox" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.search_calc,
                          expression: "search_calc",
                        },
                      ],
                      staticClass: "MMV__searchbox__input",
                      attrs: {
                        type: "text",
                        placeholder: _setup.props.placeholder,
                      },
                      domProps: { value: _setup.search_calc },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _setup.search_calc = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _setup.search_calc
                      ? _c(
                          "button",
                          {
                            staticClass: "MMV__searchbox-icon-reset",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _setup.reset_click.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(_setup.vReset, {
                              staticClass: "vicon-red reset",
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(_setup.vSearch, {
                      staticClass: "vicon-greyfigma MMV__searchbox-search",
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "MMV__aftersearchbox",
                class: { _open: _setup.isFootExpanded },
              },
              _vm._l(_setup.aftersearchbox, function (option) {
                return _c(_setup.MyMultiVertOption, {
                  key: option.id,
                  attrs: { item: option },
                  on: { input: _setup.set_option },
                })
              }),
              1
            ),
            _vm._v(" "),
            _setup.needSeach && _setup.needFootExpand && !_setup.search_calc
              ? _c(
                  "div",
                  {
                    staticClass: "MMV__footer",
                    class: { _open: _setup.isFootExpanded },
                    on: { click: _setup.FootExpand_click },
                  },
                  [
                    _c("button", { staticClass: "MMV__footer-title" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _setup.isFootExpanded ? "Cкрыть" : "Показать все"
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(_setup.vDown, {
                      staticClass: "vicon-bluefigma MMV__footer-icon",
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }